exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".toolbar-search{float:left;width:100%}.toolbar-search form{position:relative}.toolbar-search input[type=text]{padding-left:28px}.toolbar-search input[type=text]::-webkit-input-placeholder{text-align:center}.toolbar-search input[type=text]:-moz-placeholder{text-align:center}.search-clear{left:10px;z-index:1}.search-clear,.search-start{cursor:pointer;position:absolute;top:-2px}.search-start{right:10px;background:transparent;border:none;color:#47525d}.search-start:focus{outline:none}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ../~/css-loader!../~/sass-loader!./components/search/search.scss
 ** module id = 305
 ** module chunks = 0
 **/